import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {STORAGE_CACHE_KEYS} from "../Session/cachedLocalStorage";
import {getStashedUser, writeUserToLocalStorage} from "../lib/userStash";

const CURRENT_USER_KEY = STORAGE_CACHE_KEYS.EMAIL_USER || 'aag_user';

/**
 * 2025-08 Migrate all emailUser storage to Redux
 *
 *
 */
function createInitialState() {
  try {
    return {
      // customer: // FUTURE: customer as managed by back-end.

      // emailUser - user as managed by Klaviyo
      emailUser: getStashedUser()
    }
  } catch (err) {
    console.error("userSlice#createInitialState", err);
  }
}

// on STARTUP, read from localStorage!
const initialState = createInitialState();

// Stores the user.
export const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    // merge in anything
    mergeState: (state, action) => {
      const {payload} = action;
      console.log("- userSlice.mergeState", payload);
      Object.assign(state, payload);
    },
  }
});

/**
 * This is the main way that a user from Klaviyo is injected
 * into Redux (and also LocalStorage, for the next time the page loads).
 *
 * setEmailUser({user: { stuff }}
 *
 * @type {AsyncThunk<void, void, AsyncThunkConfig>}
 */
export const setEmailUser = createAsyncThunk(
  "setEmailUser",
  (payload, thunkAPI) => {

    // if email member is missing, consider it null
    const user = (payload && payload.email) ? payload : null;

    console.log(`userSlice.setEmailUser: ${JSON.stringify(user, null, 2)}`)

    writeUserToLocalStorage(user);

    thunkAPI.dispatch(userSlice.actions.mergeState({emailUser: user}));
  }
);

export default userSlice;
